import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-files-admin',
  templateUrl: './files-admin.component.html',
  styleUrls: ['./files-admin.component.scss']
})
export class FilesAdminComponent implements OnInit {

  constructor() {}

  ngOnInit() {

  }
}
